export default __webpack_public_path__ + "static/media/document-logo-5-active.825ec8bb.svg";